import { render, staticRenderFns } from "./GroupsUsers.vue?vue&type=template&id=66b7ef33&scoped=true"
import script from "./GroupsUsers.vue?vue&type=script&lang=js"
export * from "./GroupsUsers.vue?vue&type=script&lang=js"
import style0 from "./GroupsUsers.vue?vue&type=style&index=0&id=66b7ef33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b7ef33",
  null
  
)

export default component.exports